var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #eaeaea;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #e94b35;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.59,3.59c-.13-1.7-1.63-3.09-3.33-3.09H14.74c-1.7,0-3.2,1.39-3.33,3.09l-6.9,92.16c-.13,1.7,1.16,3.09,2.87,3.09h55.24c1.7,0,2.99-1.39,2.87-3.09L58.59,3.59Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.64,98.84H7.36c-1.7,0-3-1.39-2.87-3.09l.22-2.97h60.57l.22,2.97c.13,1.7-1.16,3.09-2.87,3.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.31,95.85H4.69c0-1.28-4.65-1.28-4.65,0,0,2.56,2.08,4.65,4.65,4.65h60.61c2.56,0,4.65-2.08,4.65-4.65,0-1.28-4.65-1.28-4.65,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCup);
export default __webpack_public_path__ + "static/media/red-cup.3410f93ea83b6e21ba46a3b33b0199fa.svg";
export { ForwardRef as ReactComponent };